<template>
    <div v-bind:class="'col-md-'+validConfig.col"> 
        <label>{{ validConfig.holder }}:</label>
        <div class="form-group">
            <div  class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text ">  
                        <i  v-if="isError.bool" class="fas fa-check-double"></i>                       
                        <i  v-else v-on:click="isErrormsg(isError)" class="fa fa-exclamation-triangle text-danger skew-shake-y" style="cursor:pointer" ></i>
                    </span>
                </div>
                <select 
                    :id="validConfig.id" 
                    :value="modelSelect" 
                    v-on:change="$emit('updateSelect',($event!.target as HTMLInputElement)!.value,validConfig.name)" 
                    class="form-control" 
                    v-bind:class="isError.class" 
                    :placeholder="validConfig.holder"
                    :disabled="statusInput">
                    <option value="" >{{ validConfig.holder }}</option>
                    <option v-for="(item,index) in data" :value="item.id" :key="index"> {{ item.name }} </option>
                </select>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
    import {  reactive,toRefs, watchEffect} from "vue";
    import validate from '../../composable/useValidate'
    import messages from '../../composable/useMessages'
    
    const { longitud } = validate();
    const { validateNotification } = messages();

    const props = withDefaults(defineProps<{
        modelSelect :string,
        data :Array<{id?:string,name?:string}>,
        validConfig :{ value : string, validate : boolean, name : string, message : string, col : number, min : number, max : number, empaty : number, holder : string, id : string },
        statusInput?: boolean
    }>(), {
        statusInput: false
    });

    const emit = defineEmits<{
       (e: 'updateStatus', name: string,status:boolean): void
       (e: 'updateSelect', value: string,name:string): void
    }>()

    const { validConfig, modelSelect } = toRefs(props);
    
    let isError = reactive({ validate: false, class: "", required: validConfig.value.message, bool: true }  );

    const isErrormsg = (dto: object) => { validateNotification(dto); }
    
    watchEffect(() => {
        isError = longitud(modelSelect.value, validConfig.value.empaty, validConfig.value.min, validConfig.value.max, isError.required);
        
        if(isError.validate){  
            emit('updateStatus', validConfig.value.name, isError.validate); 
            emit('updateSelect',  modelSelect.value, validConfig.value.name  );
        }else{       
            emit('updateStatus', validConfig.value.name, isError.validate); 
            emit('updateSelect',  modelSelect.value, validConfig.value.name);   
        }
    })    

</script>